// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1-JSH","buttons":"SendReceipts_buttons__2F_SH","email":"SendReceipts_email__2RNJ2","bookApptTitle":"SendReceipts_bookApptTitle__Y2Vdo"};